import { useQuery } from '@tanstack/react-query'

import { PipelineJob } from '@sparkai/shared-types'

import { apiClient } from '../../apiClient'

export const PIPELINE_JOB_FOR_ENGAGEMENT_QUERY_KEY = 'pipeline-job-for-engagement'

export function useGetPipelineJobForEngagement(
  programId?: string,
  pipelineJobId?: string,
  engagementId?: string,
  programConfigVersionId?: string | null
) {
  return useQuery({
    queryKey: [
      PIPELINE_JOB_FOR_ENGAGEMENT_QUERY_KEY,
      programId,
      pipelineJobId,
      programConfigVersionId ?? engagementId,
    ],
    queryFn: async () => {
      const params = engagementId ? `?engagementId=${engagementId}` : ''
      return (
        await apiClient.get<PipelineJob>(
          `/int/v3/programs/${programId}/pipeline-jobs/${pipelineJobId}${params}`
        )
      ).data
    },
    enabled: Boolean(programId && pipelineJobId && engagementId),
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnWindowFocus: false,
  })
}
